import React__default from 'react';
import { useTranslate } from '@awardit/react-use-translate';
import useFormat from '../../helpers/use-format.js';
import Dropdown from '../Dropdown/basic.js';
import '../Dropdown/searchable.js';
import DropdownItem from '../Dropdown/item.js';

var DropdownSelect = function DropdownSelect(_ref) {
  var items = _ref.items,
    value = _ref.value,
    onChange = _ref.onChange,
    attribute = _ref.attribute;
  var t = useTranslate();
  var _useFormat = useFormat(),
    formatPrice = _useFormat.formatPrice;
  return /*#__PURE__*/React__default.createElement(Dropdown, {
    key: attribute.name,
    placeholder: t("PRODUCT.OPTION_DROPDOWN_PLACEHOLDER"),
    value: value,
    onChange: onChange
  }, items.map(function (item) {
    return /*#__PURE__*/React__default.createElement(DropdownItem, {
      key: item.key || attribute.name + (item.buyRequest || ""),
      disabled: item.buyRequest === null,
      value: item.buyRequest || ""
    }, attribute.showConfigPrice !== undefined && attribute.showConfigPrice && item.price ? item.label + " - " + formatPrice(item.price.incVat) : item.label);
  }));
};
var DropdownSelectCustom = function DropdownSelectCustom(_ref2) {
  var items = _ref2.items,
    value = _ref2.value,
    onChange = _ref2.onChange,
    attribute = _ref2.attribute;
  var t = useTranslate();
  return /*#__PURE__*/React__default.createElement(Dropdown, {
    key: attribute.name,
    placeholder: t("PRODUCT.OPTION_DROPDOWN_PLACEHOLDER"),
    value: value,
    onChange: onChange
  }, items.map(function (item) {
    return /*#__PURE__*/React__default.createElement(DropdownItem, {
      key: item.key || attribute.name + (item.id || ""),
      disabled: item.id === null,
      value: item.id || ""
    }, item.label);
  }));
};

export { DropdownSelect, DropdownSelectCustom };
//# sourceMappingURL=dropdown.js.map
